<template>
    <div>
        <el-dialog v-if="dialogVisible" v-el-drag-dialog :title="title" :visible.sync="dialogVisible" width="1200px" :close-on-click-modal="false" :before-close="handleClose">
            <div>
                <div>
                    <!-- <el-tabs v-model="activeName" @tab-click="handleClick"> -->
                        <!-- <el-tab-pane :label="$tx('dcdb.cbgz.basicInfo', '基本信息')" name="first"> -->
                            <el-form>
                                <div class="el-table el-table--fit el-table--border">
                                    <div class="el-table__body-wrapper">
                                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                                            <tbody>
                                                <tr>
                                                    <td v-field-lbl="'flCreateDept'" colspan="1" class="el-table__cell tdlbl tdw17">创建部门</td>
                                                    <td colspan="2" class="el-table__cell tdcont tdw33">{{ matterData.flCreateDept }}</td>
                                                    <td v-field-lbl="'flCreateDate'" colspan="1" class="el-table__cell tdlbl tdw17">创建日期</td>
                                                    <td colspan="2" class="el-table__cell tdcont tdw33">{{ matterData.flCreateDate | timeFormat }}</td>
                                                </tr>
                                                <tr>
                                                    <td v-field-lbl="'flCreator'" colspan="1" class="el-table__cell tdlbl tdw17">创建人</td>
                                                    <td colspan="2" class="el-table__cell tdcont tdw33">{{ matterData.flCreator }}</td>
                                                    <td v-field-lbl="'flCreatorPhone'" colspan="1" class="el-table__cell tdlbl tdw17">联系电话</td>
                                                    <td colspan="2" class="el-table__cell tdcont tdw33">{{ matterData.flCreatorPhone }}</td>
                                                </tr>
                                                <tr>
                                                    <td v-field-lbl="'flSubject'" colspan="1" class="el-table__cell tdlbl tdw17">事项标题</td>
                                                    <td colspan="5" class="el-table__cell tdcont tdw83">{{ matterData.flSubject }}</td>
                                                </tr>
                                                <tr>
                                                    <td v-field-lbl="'dbType'" colspan="1" class="el-table__cell tdlbl tdw17">督办类型</td>
                                                    <td colspan="2" class="el-table__cell tdcont tdw33">{{ matterData.dbType }}</td>
                                                    <td v-field-lbl="'dbMode'" colspan="1" class="el-table__cell tdlbl tdw17">督办模式</td>
                                                    <td colspan="2" class="el-table__cell tdcont tdw33">{{ dbModeFormat(matterData.dbMode) }}</td>
                                                </tr>
                                                <tr>
                                                    <td v-field-lbl="'importantLevel'" colspan="1" class="el-table__cell tdlbl tdw17">重要程度</td>
                                                    <td colspan="2" class="el-table__cell tdcont tdw33">{{ importantLevelFormat(matterData.importantLevel) }}</td>
                                                    <td v-field-lbl="'urgentLevel'" colspan="1" class="el-table__cell tdlbl tdw17">紧急程度</td>
                                                    <td colspan="2" class="el-table__cell tdcont tdw33">{{ urgentLevelFormat(matterData.urgentLevel) }}</td>
                                                </tr>
                                                <tr>
                                                    <td v-field-lbl="'dbSource'" colspan="1" class="el-table__cell tdlbl tdw17">督办来源</td>
                                                    <td colspan="2" class="el-table__cell tdcont tdw33">{{ dbSourceFormat(matterData.dbSource) }}</td>
                                                    <td v-field-lbl="'dbMater'" colspan="1" class="el-table__cell tdlbl tdw17">督办人</td>
                                                    <td colspan="2" class="el-table__cell tdcont tdw33">{{ matterData.dbMater }}</td>
                                                </tr>

                                                <tr>
                                                    <td colspan="1" class="el-table__cell tdlbl tdw17">督办部门</td>
                                                    <td colspan="2" class="el-table__cell tdcont tdw33">{{ matterData.dbMaterDept }}</td>
                                                    <td colspan="1" class="el-table__cell tdlbl tdw17">督办人联系方式</td>
                                                    <td colspan="2" class="el-table__cell tdcont tdw33">{{ matterData.dbMaterLinkInfo }}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="1" class="el-table__cell tdlbl tdw17">任务标题</td>
                                                    <td colspan="5" class="el-table__cell tdcont tdw83">{{ matterData.taskData.title }}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="1" class="el-table__cell tdlbl tdw17">任务内容</td>
                                                    <td colspan="5" class="el-table__cell tdcont tdw83">{{ matterData.taskData.content }}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="1" class="el-table__cell tdlbl tdw17">主办部门</td>
                                                    <td colspan="2" class="el-table__cell tdcont tdw33">{{ matterData.taskData.qtDept }}</td>
                                                    <td colspan="1" class="el-table__cell tdlbl tdw17">配合部门</td>
                                                    <td colspan="2" class="el-table__cell tdcont tdw33">{{ matterData.taskData.phDept }}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="1" class="el-table__cell tdlbl tdw17">开始日期</td>
                                                    <td colspan="2" class="el-table__cell tdcont tdw33">{{ matterData.taskData.startDate }}</td>
                                                    <td colspan="1" class="el-table__cell tdlbl tdw17">完成时限</td>
                                                    <td colspan="2" class="el-table__cell tdcont tdw33">{{ matterData.taskData.overDate }}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="1" class="el-table__cell tdlbl tdw17">任务编号</td>
                                                    <td colspan="2" class="el-table__cell tdcont tdw33">{{ matterData.taskData.taskCode }}</td>
                                                    <td colspan="1" class="el-table__cell tdlbl tdw17">任务状态</td>
                                                    <td colspan="2" class="el-table__cell tdcont tdw33">{{ taskStatusFn(matterData.taskData.taskStatus) }}</td>
                                                </tr>

                                                <tr>
                                                    <td v-field-lbl="'remark'" colspan="1" class="el-table__cell tdlbl tdw17">备注</td>
                                                    <td colspan="5" class="el-table__cell tdcont tdw83">{{ matterData.remark }}</td>
                                                </tr>
                                                <!-- <tr>
                                                    <td v-field-lbl="'qsLimit'" colspan="1" class="el-table__cell tdlbl tdw17">签收时限</td>
                                                    <td colspan="2" class="el-table__cell tdcont tdw33">{{ matterData.qsLimit }}</td>
                                                    <td v-field-lbl="'hbTime'" colspan="1" class="el-table__cell tdlbl tdw17">汇报时间</td>
                                                    <td colspan="2" class="el-table__cell tdcont tdw33">{{ matterData.hbTime }}</td>
                                                </tr> -->
                                                <!-- <tr>
                                                    <td v-field-lbl="'signWarning'" colspan="1" class="el-table__cell tdlbl tdw17">签收预警</td>
                                                    <td v-text-lbl="'dcdb.cbgz.signWarningStr'" colspan="5" class="el-table__cell tdcont tdw83">工作汇报时限前2天未签收,发黄牌预警,工作签收时限前1天未汇报,发红牌预警</td>
                                                </tr>
                                                <tr>
                                                    <td v-field-lbl="'reportWarning'" colspan="1" class="el-table__cell tdlbl tdw17">汇报预警</td>
                                                    <td v-text-lbl="'dcdb.cbgz.reportWarningStr'" colspan="5" class="el-table__cell tdcont tdw83">工作汇报时限前2天未汇报,发黄牌预警,工作汇报时限前1天未汇报,发红牌预警</td>
                                                </tr>
                                                <tr>
                                                    <td v-field-lbl="'taskWarning'" colspan="1" class="el-table__cell tdlbl tdw17">任务预警</td>
                                                    <td v-text-lbl="'dcdb.dblcb.taskWarningStr'" colspan="5" class="el-table__cell tdcont tdw83">任务完成时限前2天未完成,发黄牌预警,任务完成时限前1天未汇报,发红牌预警</td>
                                                </tr> -->
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </el-form>
                        <!-- </el-tab-pane> -->
                        <!-- <el-tab-pane :label="$tx('dcdb.cbgz.supervisionTasks', '督办任务')" name="second">
                            <el-table :data="tableData" border style="width: 100%" @row-click="rowClick">
                                <el-table-column type="index" :label="$tx('fields.index', '序号')" width="50" align="center" />
                                <el-table-column prop="title" :label="$tx('dcdb.dblcb.title', '标题')" :show-overflow-tooltip="true" />
                                <el-table-column prop="qtDept" align="center" :label="$tx('dcdb.cbgz.fields.qtDept', '主办部门')" width="150" :show-overflow-tooltip="true" />
                                <el-table-column prop="phDept" align="center" width="150" :label="$tx('dcdb.cbgz.fields.phDept', '配合部门')" :show-overflow-tooltip="true" />
                                <el-table-column prop="startDate" align="center" width="130" :label="$tx('fields.startTime', '开始时间')" :show-overflow-tooltip="true">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.startDate | timeFormat }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="overDate" align="center" width="130" :label="$tx('fields.overDate', '完成时限')" :show-overflow-tooltip="true">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.overDate | timeFormat }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="address" align="center" width="80" :label="$tx('common.attach', '附件')">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.passenger.attachSize }}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane> -->
                    <!-- </el-tabs> -->
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button v-pageBtn-lbl="'cancel'" @click="dialogVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
        <Basicform v-if="BusiFormShow" :title="formTitle" :win-width="moduleInfo.winWidth" :win-height="moduleInfo.winHeight" :module-code="moduleInfo.moduleCode" :toolbar-btns="busiformBtns" :on-basic-form-before-open="onBasicFormBeforeOpen" :on-basic-form-opened="onBasicFormOpened">
            <template #default="slotProps">
                <busi-form :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
            </template>
        </Basicform>
    </div>
</template>

<script>
const moment = require('moment')
export default {
    filters: {
        timeFormat(val) {
            if (!val) return ''
            return moment(new Date(val)).format('YYYY年MM月DD日')
        }
    },
    components: {},
    props: {},
    data() {
        return {
            title: '',
            dialogVisible: false,
            loginUser: this.$store.getters.loginUser,
            activeName: 'first',
            matterData: {},
            tableData: [],
            formTitle: '',
            BusiFormShow: false,
            busiformBtns: [],
            moduleInfo: {
                winWidth: 900,
                winHeight: 600,
                formTemplate: 'dcontent/busiformurl?vwtype=W&url=/dcdb/task/form.html',
                delUrl: '/dcdb/task/delete',
                addNewUrl: '/dcdb/task/addNew',
                insertUrl: '/dcdb/task/insert',
                moduleCode: 'task',
                updateUrl: '/dcdb/task/update',
                listDataUrl: '/dcdb/task/listdata',
                getByIdUrl: '/dcdb/task/getById'
            }
        }
    },
    computed: {},
    watch: {},
    created() {
        this.rowId = this.$route.query.id
        this.$bus.on('openDblxFormDialog', this.openDblxFormDialog)
    },
    beforeDestroy() {
        this.$bus.off('openDblxFormDialog', this.openDblxFormDialog)
    },
    mounted() {},
    methods: {
        taskStatusFn(val) {
            var str = val
            switch (val) {
                case 0:
                    str = '未交办'
                    break
                case 1:
                    str = '执行中'
                    break
                case 2:
                    str = '已完成'
                    break
                case 3:
                    str = '已办结'
                    break
                case 4:
                    str = '办结中'
                    break
                case 8:
                    str = '已归档'
                    break
                case 9:
                    str = '已取消'
                    break
                default:
                    break
            }
            return str
        },
        // 督办类型
        dbTypeFormat(val) {
            var str = val
            switch (val) {
                case 0:
                    str = this.$tx('dcdb.cbgz.fields.documentSupervision', '会议决定')
                    break
                case 1:
                    str = this.$tx('dcdb.cbgz.fields.leadershipInstructions', '领导批示')
                    break
                case 2:
                    str = this.$tx('dcdb.cbgz.fields.focus', '领导交办')
                    break
                case 3:
                    str = this.$tx('dcdb.cbgz.fields.meetingDecisions', '重要文件')
                    break
                default:
                    break
            }
            return str
        },
        // 督办模式
        dbModeFormat(val) {
            var str = ''
            switch (val) {
                case 0:
                    str = this.$tx('dcdb.cbgz.weekSupervision', '周督办')
                    break
                case 1:
                    str = this.$tx('dcdb.cbgz.monthSupervision', '月度督办')
                    break
                case 2:
                    str = this.$tx('dcdb.cbgz.quarterSupervision', '季度督办')
                    break
                case 3:
                    str = this.$tx('dcdb.cbgz.oneSupervision', '一次督办')
                    break
                case 4:
                    str = this.$tx('dcdb.cbgz.customSupervision', '自定义')
                    break
                default:
                    break
            }
            return str
        },
        // 重要程度
        importantLevelFormat(val) {
            var str = ''
            switch (val) {
                case 0:
                    str = this.$tx('dcdb.cbgz.ordinary', '普通')
                    break
                case 1:
                    str = this.$tx('dcdb.cbgz.important', '重要')
                    break
                case 2:
                    str = this.$tx('dcdb.cbgz.veryImportant', '非常重要')
                    break
                default:
                    break
            }
            return str
        },
        // 紧急程度
        urgentLevelFormat(val) {
            var str = ''
            switch (val) {
                case 0:
                    str = this.$tx('dcdb.cbgz.regular', '平件')
                    break
                case 1:
                    str = this.$tx('dcdb.cbgz.emergent', '紧急')
                    break
                case 2:
                    str = this.$tx('dcdb.cbgz.Urgent', '特急')
                    break
                case 3:
                    str = this.$tx('dcdb.cbgz.extraUrgent', '特急')
                    break
                default:
                    break
            }
            return str
        },
        // 督办来源
        dbSourceFormat(val) {
            var str = ''
            switch (val) {
                case 0:
                    str = this.$tx('dcdb.components.assignedSuperiorUnits', '上级单位交办')
                    break
                case 1:
                    str = this.$tx('dcdb.components.AssignedLevel', '决策层交办')
                    break
                case 2:
                    str = this.$tx('dcdb.components.departmentLeadersAssigned', '部门领导交办')
                    break
                case 3:
                    str = this.$tx('dcdb.components.gwjb', '公文交办')
                    break
                case 4:
                    str = this.$tx('dcdb.components.hyjb', '会议交办')
                    break
                default:
                    break
            }
            return str
        },
        // 督办来源
        overStatusFormat(val) {
            var str = ''
            switch (val) {
                case 0:
                    str = this.$tx('dcdb.cbgz.isFinish', '已完成')
                    break
                case 1:
                    str = this.$tx('dcdb.cbgz.isPushing', '推进中')
                    break
                case 2:
                    str = this.$tx('dcdb.cbgz.lag', '滞后')
                    break
                case 3:
                    str = this.$tx('dcdb.cbgz.partialLag', '部分滞后')
                    break
                case 4:
                    str = this.$tx('dcdb.cbgz.extension', '延期')
                    break
                case 5:
                    str = this.$tx('dcdb.cbgz.extensionApplication', '延期申请中')
                    break
                case 6:
                    str = this.$tx('dcdb.cbgz.cancelApplication', '取消申请中')
                    break
                default:
                    break
            }
            return str
        },
        openDblxFormDialog(id) {
            this.title = this.$tx('dcdb.dblcb.superviseProjectApproval', '督办立项')
            this.$http({
                contentType: 'application/x-www-form-urlencoded',
                url: `/dcdb/matter/getDblxInfo`,
                method: 'POST',
                params: { id: id }
            }).then((res) => {
                if (res.code === 'success') {
                    this.matterData = res.body.matter || {}
                    this.tableData = res.body.task
                    if (res.body.task.length > 0) {
                        this.matterData.taskData = res.body.task[0]
                    } else {
                        this.matterData.taskData = {}
                    }
                    this.dialogVisible = true
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 行点击
        rowClick(row, column, event) {
            var _this = this
            _this.formTitle = _this.$tx('dcdb.cbgz.supervisionTasks', '督办任务')
            _this.busiformBtns = [
                {
                    id: 'btn_close',
                    btnName: '关 闭',
                    btnIcon: 'close',
                    btnClick: 'closeDialog',
                    btnPermission: '',
                    btnType: ''
                }
            ]
            _this.BusiFormShow = true
            _this.moduleInfo.formTemplate = '#/dcontent/vuebusiform/W/dcdb.task.form.vue?sysCode='
            _this.$options.components['BusiForm'] = _this.$loadComponent(_this.moduleInfo.formTemplate)
            _this.$nextTick(() => {
                _this.$bus.emit('openBusiform', _this.moduleInfo, row, 0, (res) => {
                    _this.BusiFormShow = false
                })
            })
        },
        handleClick(val) {
            console.log('val', val)
        },
        // 弹出关闭
        handleClose() {
            this.tableData = []
            this.matterData = {}
            this.activeName = 'first'
            this.dialogVisible = false
        },
        /**
         * 表单打开检查，vo为已加载salary对象，允许打开：defer.resolve(true)，阻止打开：defer.reject(reason)
         */
        onBasicFormBeforeOpen: function ($scope, vo, defer) {
            if (process.env.NODE_ENV === 'development') console.log('salary form before open')
            defer.resolve(true)
        },
        /**
         * 表单打开完成，vo为已加载的salary对象，前端页面dom对象已完成初始化、已经呈现，不需要返回值
         */
        onBasicFormOpened: function ($scope, vo) {
            if (process.env.NODE_ENV === 'development') console.log('salary form opened')
        }
    }
}
</script>

<style scoped lang="scss">
</style>
